// Plantillas prediseñadas para el Editor de Artes.
// Cada plantilla carga un fondo (servido same-origin desde /templates) y capas de
// texto editables. `uses` define el orden (las más usadas primero).
// Posiciones x/y en % del lienzo (1080x1080). size en px sobre lienzo de 1080.

const L = (o) => ({
  font: 'Arial', size: 48, color: '#FFFFFF', strokeColor: '#000000', strokeWidth: 3,
  x: 50, y: 50, bold: true, italic: false, align: 'center', shadow: true, maxWidth: 84, ...o,
});

export const ART_TEMPLATE_CATEGORIES = [
  {
    id: 'loteria',
    name: 'Lotería y Juegos',
    templates: [
      {
        id: 'resultados_loteria',
        name: 'Resultados de lotería',
        uses: 100,
        bg: '/templates/lottery_sunset.jpg',
        layers: [
          L({ text: 'SORTEO DE HOY', size: 62, y: 12, color: '#FFF4D6' }),
          L({ text: 'Hora: 7:00 PM', size: 40, y: 24, color: '#FFFFFF' }),
          L({ text: '00  00  00', size: 120, y: 50, color: '#FFE14D', strokeColor: '#7A3E00', strokeWidth: 5 }),
          L({ text: 'Tel: 8888-8888', size: 40, y: 90, color: '#FFFFFF' }),
        ],
      },
      {
        id: 'casino_chances',
        name: 'Casino / Chances',
        uses: 60,
        bg: '/templates/casino_neon.jpg',
        layers: [
          L({ text: 'NOMBRE DEL JUEGO', size: 60, y: 14, color: '#FF57E6' }),
          L({ text: 'RESULTADOS', size: 44, y: 30, color: '#66E0FF' }),
          L({ text: '00 - 00 - 00', size: 110, y: 52, color: '#FFD84D', strokeColor: '#000000', strokeWidth: 5 }),
          L({ text: 'Contacto: 8888-8888', size: 40, y: 90, color: '#FFFFFF' }),
        ],
      },
    ],
  },
  {
    id: 'celebraciones',
    name: 'Celebraciones',
    templates: [
      {
        id: 'fiesta_evento',
        name: 'Fiesta / Evento',
        uses: 85,
        bg: '/templates/party_confetti.jpg',
        layers: [
          L({ text: 'NOMBRE DEL EVENTO', size: 64, y: 30, color: '#E4007C' }),
          L({ text: 'Fecha: 00 / 00 / 0000', size: 42, y: 46, color: '#333333', strokeColor: '#FFFFFF', strokeWidth: 2 }),
          L({ text: 'Hora: 0:00 PM', size: 42, y: 56, color: '#333333', strokeColor: '#FFFFFF', strokeWidth: 2 }),
          L({ text: 'Lugar: ___________', size: 40, y: 66, color: '#333333', strokeColor: '#FFFFFF', strokeWidth: 2 }),
          L({ text: 'Contacto: 8888-8888', size: 38, y: 90, color: '#E4007C', strokeColor: '#FFFFFF', strokeWidth: 2 }),
        ],
      },
      {
        id: 'cumpleanos',
        name: 'Cumpleaños',
        uses: 90,
        bg: '/templates/birthday.jpg',
        layers: [
          L({ text: '¡FELIZ CUMPLEAÑOS!', size: 58, y: 30, color: '#7B2FF7' }),
          L({ text: 'Nombre', size: 70, y: 46, color: '#E4007C' }),
          L({ text: '00 años', size: 54, y: 60, color: '#00A3A3' }),
          L({ text: 'Mensaje especial aquí', size: 38, y: 88, color: '#333333', strokeColor: '#FFFFFF', strokeWidth: 2 }),
        ],
      },
    ],
  },
  {
    id: 'negocio',
    name: 'Negocio',
    templates: [
      {
        id: 'promocion_tienda',
        name: 'Promoción de tienda',
        uses: 95,
        bg: '/templates/store_promo.jpg',
        layers: [
          L({ text: 'PRODUCTO', size: 66, y: 20, color: '#FFFFFF' }),
          L({ text: '₡0.000', size: 120, y: 46, color: '#FFE14D', strokeColor: '#B00000', strokeWidth: 5 }),
          L({ text: 'Descripción del producto', size: 38, y: 66, color: '#FFFFFF' }),
          L({ text: 'Contacto: 8888-8888', size: 40, y: 90, color: '#FFFFFF' }),
        ],
      },
      {
        id: 'oferta_dia',
        name: 'Oferta del día',
        uses: 88,
        bg: '/templates/offer_urgency.jpg',
        layers: [
          L({ text: '¡OFERTA DEL DÍA!', size: 60, y: 14, color: '#B00000', strokeColor: '#FFFFFF', strokeWidth: 3 }),
          L({ text: 'Producto en oferta', size: 44, y: 30, color: '#7A3E00', strokeColor: '#FFFFFF', strokeWidth: 2 }),
          L({ text: 'Antes ₡0.000', size: 40, y: 46, color: '#7A3E00', strokeColor: '#FFFFFF', strokeWidth: 2 }),
          L({ text: 'AHORA ₡0.000', size: 96, y: 62, color: '#B00000', strokeColor: '#FFE14D', strokeWidth: 5 }),
          L({ text: 'Vigencia: solo hoy', size: 38, y: 90, color: '#B00000', strokeColor: '#FFFFFF', strokeWidth: 2 }),
        ],
      },
      {
        id: 'tarjeta_presentacion',
        name: 'Tarjeta de presentación',
        uses: 70,
        bg: '/templates/business_card.jpg',
        layers: [
          L({ text: 'Nombre Apellido', size: 60, y: 30, color: '#FFD98A' }),
          L({ text: 'Puesto', size: 40, y: 42, color: '#FFFFFF' }),
          L({ text: 'Empresa', size: 44, y: 54, color: '#FFD98A' }),
          L({ text: 'Tel: 8888-8888', size: 36, y: 74, color: '#FFFFFF' }),
          L({ text: '@redes_sociales', size: 34, y: 82, color: '#FFFFFF' }),
        ],
      },
    ],
  },
];

// Lista plana ordenada por popularidad (más usadas primero) con su categoría.
export const ART_TEMPLATES_FLAT = ART_TEMPLATE_CATEGORIES
  .flatMap((c) => c.templates.map((t) => ({ ...t, categoryName: c.name, categoryId: c.id })))
  .sort((a, b) => (b.uses || 0) - (a.uses || 0));
